module.exports = __webpack_public_path__ + "img/schgz-text.c9ab1551.png";